<template>
  <div>
    <div class="seachBox flex">
      <div class="seachList"><span class="name">关键词：</span>
        <a-input placeholder="请输入指令词" class="seachs" v-model="seach.keyword"/>
      </div>
      <div class="seachList  ">
        <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
          查询
        </a-button>
        <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
      </div>
      <div class="seachList no"></div>
      <div class="seachList no"></div>
      <div class="seachList no"></div>
    </div>
    <a-button class="top_btn" type="primary" @click="()=>{  visible = true; title='添加指令' }"  > 添加
    </a-button>
    <p style="color: #f00">注：{product_name}表示客户前台填的“产品名称”、{industry_category}表示客户前台填的“所属行业”、{landing_pages}表示客户前台填的“着陆页链接”、{seed_keywords}表示客户前台填的“种子关键词”、{daily_budget}表示客户前台填的“总日预算”、{core_business_goal}表示客户前台填的“核心业务目标”、{target_audience}表示客户前台填的“采购群体画像”、{USP}表示客户前台填的“核心竞争优势（USP）”、{brand_keywords}表示客户前台填的“品牌词“、{core_conversion_action}表示客户前台填的“核心转化动作”、{target_CPA}表示客户前台填的“目标 CPA”、{competitors}表示客户前台填的“竞争对手网址”，{Part1}表示“投放类型及预算分配”输出内容。</p>

    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
            <span slot="status" slot-scope="text, record">
                <a-switch @click="onChange(record)" :checked="text==1?true:false" />
            </span>
      <span slot="action" slot-scope="text, record">
                <a @click="(record)=>{visible = true;  title='编辑指令'; editId=text.id ; }" >编辑</a>
            </span>
    </a-table>
    <a-pagination
        :current="pagination.current"
        :total="pagination.total"
        :pageSize="pagination.pageSize"
        :showSizeChanger="true"
        :showQuickJumper="true"
        :showTotal="(total, range) => `共 ${total} 条`"
        @change="getList"
        @showSizeChange="onShowSizeChange"
        style="margin-top: 20px; text-align: right;"
    />
    <InstructionForm :visible="visible" :title="title" :editId="editId"
                     @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>
  </div>
</template>

<script>
import API from "./api";
import moment from 'moment';
import InstructionForm from "./components/instructionForm"
import {changStatus} from "../../../utils/utils"
const columns = [
  {
    title: "序号",
    dataIndex: "id",
    key: "id",
    width: "100px",
  },
  {
    title: "投放类型及预算分配",
    dataIndex: "instructions_budget",
    ellipsis: true,
    key: "instructions_budget"
  },
  {
    title: "搜索广告账户结构",
    dataIndex: "instructions_search",
    ellipsis: true,
    key: "instructions_search"
  },
  {
    title: "着陆页分析",
    dataIndex: "instructions_page",
    ellipsis: true,
    key: "instructions_page"
  },
  {
    title: "状态",
    key: "status",
    width: "150px",
    dataIndex: "status",
    scopedSlots: {customRender: "status"}
  },
  {
    title: "添加时间",
    dataIndex: "create_time",
    key: "create_time",
    width: "180px",
  },
  {
    title: "修改时间",
    dataIndex: "update_time",
    key: "update_time",
    width: "180px",
  },
  {
    title: "操作",
    key: "action",
    width: "150px",
    scopedSlots: {customRender: "action"}
  }
];
export default {
  name: "googleAdsInstruction",
  data() {
    return {
      seach: {
        keyword: "",
      },
      pagination: {
        pageNo: 1,
        pageSize: 20,
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize),
        onChange: this.getList.bind(this),
        total: 0,
        current: 1,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      columns,
      loading: true,
      visible: false,
      title: "",
      editId: null
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/ai/AGoogleAdsInstructions";
  },
  mounted() {
    this.getList()
  },
  components: {InstructionForm},
  methods: {
    onChange(row) {
      let Json = {id: row.id, status: row.status == 1 ? 2 : 1}
      changStatus(API.service.CHANG_STATUS, Json).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
    resetSeach() {
      this.loading = true
      this.seach = {
        keyword: "",
      }
      this.resetSeachdata=false
      this.getList(1)
    },
    getList(page) {
      let seachData = JSON.parse(JSON.stringify(this.seach))
      API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
        this.data = res.data.data.data || res.data.data
        this.pagination.total = res.data.data.total || 0
        this.pagination.current = page || 1
        this.loading = false
      })
    },
    onShowSizeChange(current, size) {
      this.pagination.pageSize = size
      this.getList(1)
    },
  }
}
</script>

<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}
</style>
